// extracted by mini-css-extract-plugin
export default {"button":"Button_button__jtgxS","button__disabled":"Button_button__disabled__DNkcr"};